export default __webpack_public_path__ + "static/media/txt_h2.b2282c05.svg";